export default function CTABanner() {
  const handleGetStarted = () => {
    const bookingSection = document.getElementById('booking');
    if (bookingSection) {
      bookingSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="bg-gradient-to-r from-teal-600 to-teal-500 rounded-3xl overflow-hidden relative">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjEiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-30"></div>
          
          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-12 items-center p-12 lg:p-16">
            <div>
              <span className="inline-block px-4 py-2 border border-white/30 rounded-full text-xs font-medium text-white mb-6">
                Ready to Transform Your Space?
              </span>
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                Let's Create Something Beautiful Together
              </h2>
              <p className="text-white/90 text-base leading-relaxed mb-8">
                From concept to completion, we're here to bring your vision to life. Schedule a free consultation and discover how we can transform your space into something extraordinary.
              </p>
              
              <div className="flex flex-col lg:flex-row items-start lg:items-center space-y-4 lg:space-y-0 lg:space-x-4">
                <button
                  onClick={handleGetStarted}
                  className="bg-white text-gray-900 px-8 py-4 rounded-full font-medium text-base hover:bg-gray-100 transition-all flex items-center space-x-3 cursor-pointer whitespace-nowrap mb-6 lg:mb-0 w-fit"
                >
                  <span>Get Started</span>
                  <div className="w-8 h-8 bg-gray-900 rounded-full flex items-center justify-center">
                    <i className="ri-arrow-right-line text-white text-sm"></i>
                  </div>
                </button>
                
                <div className="flex items-center space-x-3 text-white">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <div>
                    <p className="text-xs text-white/70">Call us directly</p>
                    <p className="font-medium">+91 99258 98625</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-4">
                  <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-award-line text-white text-2xl"></i>
                    </div>
                    <h4 className="text-white font-bold text-2xl mb-1">500+</h4>
                    <p className="text-white/80 text-sm">Projects Completed</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-user-smile-line text-white text-2xl"></i>
                    </div>
                    <h4 className="text-white font-bold text-2xl mb-1">98%</h4>
                    <p className="text-white/80 text-sm">Client Satisfaction</p>
                  </div>
                </div>
                <div className="space-y-4 pt-8">
                  <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-team-line text-white text-2xl"></i>
                    </div>
                    <h4 className="text-white font-bold text-2xl mb-1">50+</h4>
                    <p className="text-white/80 text-sm">Expert Team</p>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6">
                    <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-time-line text-white text-2xl"></i>
                    </div>
                    <h4 className="text-white font-bold text-2xl mb-1">10+</h4>
                    <p className="text-white/80 text-sm">Years Experience</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
